import { render, staticRenderFns } from "./Deposit.vue?vue&type=template&id=612db88b&scoped=true&"
import script from "./Deposit.vue?vue&type=script&lang=js&"
export * from "./Deposit.vue?vue&type=script&lang=js&"
import style0 from "./Deposit.vue?vue&type=style&index=0&id=612db88b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "612db88b",
  null
  
)

export default component.exports